import { render } from "./VirtualScroller.vue?vue&type=template&id=3425b55e&scoped=true&ts=true"
import script from "./VirtualScroller.vue?vue&type=script&lang=ts"
export * from "./VirtualScroller.vue?vue&type=script&lang=ts"

import "./VirtualScroller.vue?vue&type=style&index=0&id=3425b55e&lang=scss&scoped=true"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3425b55e"]])

export default __exports__